import { React, Component, createRef } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { loginActions } from "../../../../store/user-login.reducer";
import { LOGIN_STATUS as loginStat, LOGIN_USER_ACCESS as userAccess, MOBILE_POLICY_URL as mobilePolicyURL, USER_GUIDE_URL as userGuideURL } from "../../../../utils/constant.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import userimage from "../../../../../../src/img/Avatar.png";
import Icon from "../../../icon";
import ButtonIcon from "../../../button";
//import { GrooveAvatar } from "tfo-groove";
import "./userprofile.component.css";
import Translation from "../../../common/translation/translation.component"
import { Link } from "react-router-dom";
import DateFormat from "./date-format/dateformat";
import { USER_ROLES_ID, EXTERNAL_LINK_TYPES, WORKFLOW_MESSAGE } from "../../../../constants/external-constants";
import { httpGet } from '../../../../utils/api.utils';
import TimeZone from "./time-zone/time-zone.component";
import ApprovalWorkFlow from "./approval-workflow/approval-workflow.component";
import ModalContainer from "../../modal/modal-container/modal-container.component";
import CrudTable from "../../details-table/crud-table.component";
import { adminSettingActions } from "../../../../store/admin-setting.reducer";
import { convertToTimeZoneDate } from "../../../../utils/helpers.utils";
import { Loading } from "../../../common/loading";

import Moment from 'moment';
class ProfileContainer extends Component {
    constructor(props) {
        super();
        this.state = ({
            showClass: "",
            modalVisible: false,
            userGuideExternalLink: "",
            mobilePolicyExternalLink: "",
            showModalForm: false,         
            showWarning: true,
            dataTable: [[]],
            approvalworkflowupdated: [],
            fieldType: [
                {
                    name: 'ApprovalWorkFlows',
                    type: 'searchabledropdown',
                    selected: 'ApprovalWorkflowId',
                    required: true,
                    data: []
                }   
            ], 
            headerTable: [],          
        })
        this.wrapperRef = createRef();
    }

    checkIfProfileClickedOutside = (e) => { 
        if (
            this.props.navToggle &&
            this.wrapperRef.current &&
            !this.wrapperRef.current.contains(e.target) &&
            !document.getElementById("modal-container")?.contains(e.target)
        ) {
            if (!this.state.modalVisible && !this.state.showModalForm) {
                this.props.onClose();
            }       
        }
    }
    

    handleModal(value) {
        this.setState({
            modalVisible:value
        });
    }

    componentDidMount() {
        window.addEventListener('mousedown', this.checkIfProfileClickedOutside);
        this.getExternalLink(EXTERNAL_LINK_TYPES.userGuide);
        this.getExternalLink(EXTERNAL_LINK_TYPES.mobilePolicy);
        this.props.getServicetypelist();
        const { headerTable } = this.state;
        //update crudtable  
        this.props.getWorkflowList().then(() => {
            const { approvalList } = this.props.adminSetting;
            const approvalListHeaderData = approvalList?.dataTable?.[0]?.HeaderItem || [];
            const approvalListDataItem   = approvalList?.dataTable?.[0]?.dataItem || [];
              
            if (approvalListHeaderData) {
                this.setState({ headerTable: [...headerTable, approvalListHeaderData[0]] })
            }

            if (approvalListDataItem) {
                this.setState((prevState) => {
                    const updatedDataTable = [...prevState.dataTable];
                    updatedDataTable[0].push(approvalListDataItem);
                    this.setState({ dataTable: updatedDataTable[0] })
                })
            }   
        })
    }

    componentDidUpdate(prevProps) {
        const { adminSetting } = this.props;
        const { fieldType } = this.state;

        let shouldUpdateFieldType = false;
        let updatedFieldType = [...fieldType];

        if (prevProps.adminSetting.Servicetypelist !== adminSetting.Servicetypelist) {
            const serviceTypleList = adminSetting.Servicetypelist;
            updatedFieldType = updatedFieldType.map((fieldData) => {
                if (fieldData.name === "ApprovalWorkFlows") {
                    shouldUpdateFieldType = true;
                    return {
                        ...fieldData,
                        data: serviceTypleList,
                    };
                }
                return fieldData;
            });
        }

        if (shouldUpdateFieldType) {
            this.setState({ fieldType: updatedFieldType });
        }
    }

    fetchUpdate = (data) => {
        this.setState({
            approvalworkflowupdated: data
        })
    }
  
    handleUpdate = async (key, fetchApprovalId, fetchModiiedId) => {  
        const { saveApprovalWorflow } = this.props       
        const ApprovalWorkFlowId = fetchApprovalId
        const ApprovalWorkflowSettingId = key
        const LastModified = fetchModiiedId
        var result = await saveApprovalWorflow(LastModified, ApprovalWorkflowSettingId, ApprovalWorkFlowId);
         
        return result;
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.checkIfProfileClickedOutside);
    }
    logout = async (e) => {


        e.preventDefault();
        this.props.logout();
    }

    getExternalLink = async (externalLinkId) => {

        var url = 'external/externallink/getExternalLink?externalLinkID=' + externalLinkId;

        var res = await httpGet(url);

        if (res) {
            if (externalLinkId == 1)
            {
                this.setState({
                    userGuideExternalLink: res[0].URL
                });
            }
            else {
                this.setState({
                    mobilePolicyExternalLink: res[0].URL
                });
            }
        }
      
    };

    updateData = (key,newData) => {
        const { activeTimeZoneOffset } = this.props.adminSetting;
        this.setState((prevState) => {
            const updatedDataTable = [...prevState.dataTable];

            if (Array.isArray(updatedDataTable)) {

                const index = updatedDataTable[0].findIndex((item) => item.Key === key);

                if (index !== -1) {
                    updatedDataTable[0][index] = {
                        ...updatedDataTable[0][index],
                        ...newData[index],
                        LastModified: `${sessionStorage.FirstName} ${sessionStorage.LastName} on 
                                    ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('L')} ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('LT')}`,
                    }                  
                    const  fetchApprovalId = updatedDataTable[0][index].ApprovalWorkflowId
                    const fetchModiiedId = updatedDataTable[0][index].LastModified
                    this.handleUpdate(key, fetchApprovalId, fetchModiiedId)
                }
                this.fetchUpdate(updatedDataTable)
                return { dataTable: updatedDataTable };
            }

            return null;
        });
    };


    handleTableValidation = () => {

    }

    handleCloseFormModal = () => {
        this.setState({ showModalForm: false })
    }

    handleWorkFlow = (value)=>{
        this.setState({
            showModalForm:value
        })        
    }
    

    render() {
        const { showModalForm, dataTable, tableData, showWarning } = this.state;
        let userModel = JSON.parse(sessionStorage.getItem('User')).Employee;
        let loginStatus = sessionStorage.getItem('logInStatus');
        const { adminSetting } = this.props;
        let dealName = sessionStorage.getItem('DealName');
        let noAccess = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.PersonalDashboardR, ACCESS_MODULE.PersonalDashboardRE, ACCESS_MODULE.PersonalDashboardRW])
            || validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MyDirectReportsDashboardR, ACCESS_MODULE.MyDirectReportsDashboardRE, ACCESS_MODULE.MyDirectReportsDashboardRW]);

        const isSupportAdmin = sessionStorage.getItem('UserRoleID') == USER_ROLES_ID.supportAdmin;

        return (       
            <div ref={this.wrapperRef} className="external-userprofile-nav ">
                <div className="userprofile-info">                   
                    <div className="userprofile-header">
                        <div className="right-nav-profile">
                            <img src={userimage} className="cover-profile-image" />                            
                        </div>
                        <h2 className="userprofile-name">{userModel.FirstName + " " + userModel.LastName}</h2>
                        <div className="userprofile-type">{userModel?.Role?.RoleName}</div>
                    </div>
                    <div className="userprofile-data">
                        <Icon
                            customClassName="icon-email"
                            name="envelope"
                            labelValue={userModel.Email}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icon
                            customClassName="icon-mobile"
                            name="mobile-button"
                            labelValue={userModel.ContactNumber}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icon
                            customClassName="icon-location"
                            name="location-dot"
                            labelValue={userModel.Location.LocationName}
                            size="15px"
                            containerClass="icon-container"
                        />
                    </div>
                </div>
                <div className="horizontal-separator"></div>
                <div className="userprofile-references">
                    <p className="title">
                        <Translation translationKey="reference" />
                    </p>
                    <a href={this.state.userGuideExternalLink} rel="noopener noreferrer" target="_blank">
                        <Icon
                            hidden={noAccess}
                            customClassName="icon-clipboard-list"
                            name="clipboard-list-check"
                            labelValue={<Translation translationKey="user_guide" />}
                            size="20px"
                            containerClass="icon-container"
                            />
                    </a>
                    <a href={this.state.mobilePolicyExternalLink} rel="noopener noreferrer" target="_blank">
                        <Icon
                            hidden={noAccess}
                            customClassName="icon-line"
                            name="file-lines"
                            labelValue={<Translation translationKey="policy_mobile" />}
                            size="19px"
                            containerClass="icon-container"
                        />
                    </a>
                    <Link to={`/external/${dealName}/ReleaseNotes`}>
                        <Icon
                            customClassName="icon-file-code"
                            name="file-code"
                            labelValue="Release Notes"
                            size="19px"
                            containerClass="icon-container"

                        />
                    </Link>
                </div>           
                {
                    isSupportAdmin && 
                    <>
                        <div className="horizontal-separator"></div>
                        <DateFormat handleModal={this.handleModal.bind(this)} />
                        <TimeZone  handleModal={this.handleModal.bind(this)}/>
                        <ApprovalWorkFlow onClick={this.handleWorkFlow.bind(this)}/>
                        <div className="horizontal-separator"></div>

                        <ModalContainer
                            title="approval_workflow"
                            show={showModalForm}
                            handleModal={this.handleCloseFormModal}
                            hideBtn={true}
                            saveDetails={this.handlePrimaryBtn}
                            secondaryBtnFc= {this.handleSecondary}
                            customClass="cost-allocation-details__modal modal-form__container"
                            disabled={false}
                            isReadAndWrite={true}
                        >  
                            {adminSetting.isGetWorkFlowListLoaded ?  
                                <div className="table-scroll__form-modal sample">
                                    <CrudTable
                                        dataTable={dataTable[0]}
                                        headerTable={this.state.headerTable}
                                        fieldType={this.state.fieldType}
                                        updateData={this.updateData}
                                        customValidation={this.handleTableValidation}
                                        haveDeleteAndEditBtn={true}
                                        hideDeleteBtn={true}
                                        customClass={`${!showWarning ? 'mb-4' : ''}`}
                                        hasScroll={true}
                                    />
                                </div>
                                : <Loading />}          
                            {showWarning &&
                                <span className={`font-red fs-12 mb-3 d-inline-block`}>{WORKFLOW_MESSAGE.approvalWorkFlow}</span>
                            }

                        </ModalContainer> 
                    </>
                }
                
                {false ? null :
                    <ButtonIcon onClick={(e) => this.logout(e)} iconLeft="sign-out-alt" iconSize="16px" customClassName="userprofile-logout btn-custom-violet-hover-outline" labelClass="logout-label" labelName="Logout" />
                    }
                </div>        
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        ...bindActionCreators(
            Object.assign({}
                , loginActions
                , adminSettingActions
               
            ),
            dispatch
        ),          

    }
}

function mapStateToProps(state) {
    const { adminSetting } = state;
    return {
        ...state,
        ...state.history,
        adminSetting
        
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ProfileContainer);